/* eslint-disable react-hooks/rules-of-hooks */
import { CardMatriculate } from '@/components/molecules/Admin/Cards/CardMatriculate'
import { useAppDispatch } from '@/store/hooks'
import cohortsService from '@/services/cohortsService'
import Spinner from '@/components/atoms/Spinner'
import { matriculateCreators } from '@/store/ducks/matriculate'
import { useNavigate } from 'react-router-dom'

interface Course {
	id: number
	name: string
	'type-course': string
	total_classes: number
	produto: string
	categoria: string
	produto_nome: string
	nome_card: string
	capa_card?: string
	descricao?: string
	sobre_curso?: string
	carga_horaria?: string
	foto_professor?: string
	nome_professor?: string
	sobre_professor?: string
	turma?: {
		id: number
		curso_id: number
		empresa_id: number
		status: string
	}
}

interface CohortCourse {
	id: number
	name: string
	curso_id: number
	progress: string
	status: string
	'type-course': string
	categoria: string
	produto: string
}

export function CompleteCourses() {
	const { data: cohorts, isLoading } = cohortsService.getCohortsUser()
	const dispatch = useAppDispatch()
	const navigate = useNavigate()

	const handleCohortOpen = (cohortCourse: CohortCourse) => {
		const formattedCourse = {
			id: cohortCourse.id,
			name: cohortCourse.name,
			curso_id: cohortCourse.curso_id,
			progress: cohortCourse.progress,
			'type-course': cohortCourse['type-course'],
			status: cohortCourse.status,
			categoria: cohortCourse.categoria,
		}

		dispatch(matriculateCreators.setClassSelect(formattedCourse))
		navigate('/curso')
	}

	// Mapeia os cursos disponíveis e os relaciona com as turmas completadas
	const repeatedCoursesWithCohortInfo =
		cohorts?.courses.flatMap((cohortCourse: CohortCourse) => {
			if (cohortCourse.progress === '100.00%') {
				return [
					{
						...cohortCourse,
						total_classes: 0,
						cohortId: cohortCourse.id,
						'type-course': cohortCourse['type-course'],
						curso_id: cohortCourse.curso_id,
						categoria: cohortCourse.categoria,
						'name-card': cohortCourse.name,
						produto_nome: '',
						nome_card: '',
					},
				]
			}
			return []
		}) || []

	return (
		<div className='flex w-full pt-10'>
			{(() => {
				if (isLoading) {
					return (
						<div className='flex h-full w-full justify-center'>
							<Spinner />
						</div>
					)
				}

				if (!repeatedCoursesWithCohortInfo.length) {
					return (
						<div className='w-full py-3 px-4 flex items-center max-w-max border border-dashed border-white/10 rounded-xl'>
							<p className='text-base text-white font-medium'>
								Nenhum curso completo no momento
							</p>
						</div>
					)
				}

				if (repeatedCoursesWithCohortInfo.length) {
					return (
						<div className='flex flex-col gap-6 w-full'>
							<div className='grid sm:grid-cols-2 lg:grid-cols-3 max-w-[1060px] gap-4 md:gap-9 lg:gap-5 items-start'>
								{repeatedCoursesWithCohortInfo.map(
									(
										course: Course & { cohortId: number; categoria: string },
										key: number
									) => (
										<CardMatriculate
											onClick={() => {
												const cohortCourse = cohorts?.courses.find(
													(c: CohortCourse) => c.id === course.cohortId
												)

												if (cohortCourse) {
													handleCohortOpen(cohortCourse)
												}
											}}
											course={course}
											key={key}
										/>
									)
								)}
							</div>
						</div>
					)
				}

				return <></>
			})()}
		</div>
	)
}
